import axios from '../utils/axios'

export function getBriskRuleApi(params) {
  return axios.post('/funds/apiFundsAh5Service/briskRule', params)
}

export function userBriskPeriodDetailListApi(params) {
  return axios.post('/funds/apiFundsAh5Service/userBriskPeriodDetailList', params)
}

export function userBriskPeriodListApi(params) {
  return axios.post('/funds/apiFundsAh5Service/userBriskPeriodList', params)
}

// export function userBriskPeriodRankApi(params) {
//   return axios.post('/funds/apiFundsAh5Service/userBriskPeriodRank', params)
// }

export function uploadGroupScreenshotApi(params) {
  return axios.post('/funds/apiFundsAh5Service/uploadGroupScreenshot', params)
}

export function groupScreenshotDetailApi(params = {}) {
  return axios.post('/funds/apiFundsAh5Service/groupScreenshotDetail', params)
}

export function getBriskInfoApi(params = {}) {
  return axios.post('/funds/apiFundsAh5Service/userBriskPeriodDetail', params)
}

export function getUserBriskPeriodRankApi(params = {}) {
  return axios.post('/funds/apiFundsAh5Service/getUserBriskPeriodRank', params)
}

export function getIsHasUploadGroupApi(params = {}) {
  return axios.post('/funds/apiFundsAh5Service/isUploadGroupScreenshot', params)
}
